<div class="modal-header">
  <button ngbAutofocus class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" ngbAutofocus>
  <myp-inline-loader [loading]="loading" height="300px" spinnerName="simpleSignupLoader"></myp-inline-loader>
  @if (!loading) {
    <div class="row">
      <div class="col-md-12 m-b-20 text-center">
        <div>
          <div><img [src]="appService.headerLogo" style="width: 150px; margin: 0px auto 30px auto" /></div>
          <fui-heading text="One Account. All of Fender." textAlign="center"></fui-heading>
          <br />
          Sign in or create a free account to pick up right where you left off. You'll be able to comment on shared files, collaborate with Fender Studio Pro+ members, and manage all your Fender and
          PreSonus gear — including software, firmware, and more — all in one place.
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center m-t-20">
      <a class="brand-btn-reverse" style="min-width: 150px" (click)="appService.closeModals()" [routerLink]="['/login']" [queryParams]="returnToQueryParams">Sign In</a>
      &nbsp;&nbsp;&nbsp;
      <a class="brand-btn-reverse" style="min-width: 150px" (click)="appService.closeModals()" [routerLink]="['/createaccount']" [queryParams]="returnToQueryParams">Create Account</a>
    </div>
  }
</div>
